import React, { useEffect, useState, Fragment } from 'react';
import './testResult.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import Stepper from './stepper';
import { getSelectedTests, checkValidTest, updateTestName, getTenantUsers, getInvitationTemplates, sendInvites, updateAssessmentSettings } from '../../../Redux/ActionCreators/testLibraryAction';
import { getSubscriptionPlans } from '../../../Redux/ActionCreators/userAction';
import { useSelector, useDispatch } from 'react-redux';
import AddTestModal from '../../../utils/addTestModal';
import Template from './template';
import CreatableSelect from 'react-select/creatable';
import Select from 'react-select';
import { getDateAfterTwo, isDateAfter30Days, validateEmails } from '../../../utils/miscelleneous';
import moment from 'moment';
import TestDetailModal from '../../../utils/testDetailModal';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { Modal, Table } from 'react-bootstrap';
import { getAccountDetail } from '../../../Redux/ActionCreators/settingAction';
import HttpClient from "./httpClient";
import { Dialog } from '@mui/material';
import { useTranslation } from 'react-i18next';

//1- invite
// 2- reminder
export default function InvitePreview() {
    const [isOpen, setIsOpen] = useState(false);
    const [isDetail, setIsDetail] = useState(false);
    const [testName, setTestName] = useState('');
    const [testNameErr, setTestNameErr] = useState('');
    const [description, setDescription] = useState('');
    const [emails, setEmails] = useState('');
    const [emailsError, setEmailsError] = useState('');
    const [tenentEmail, setTenentEmail] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    const [date, setDate] = useState('');
    const [dateError, setDateError] = useState('');
    const [loading, setLoading] = useState(false);
    const [generatetestUrl, setGeneratetestUrl] = useState('');
    const [successMessageText, setsuccessMessageText] = useState('');
    const [successMessage, setSuccessMessage] = useState(false);
    const [successEnable, setSuccessEnable] = useState(false);
    const [isList, setIsList] = useState(false);
    const [file, setFile] = useState();
    const { t } = useTranslation();
    const [array, setArray] = useState([]);
    const [errors, setErrors] = useState([]);
    const [dataInCSV, setDataInCSV] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [shouldValidate, setShouldValidate] = useState(false);
    const [modalMessage, setModalMessage] = useState(t('Please upgrade your plan to generate link'));
    const [assessmentRemaining, setAssessmentRemaining] = useState(null);
    const [subscriptionLoaded, setSubscriptionLoaded] = useState(false);
    const [attemptLimit, setAttemptLimit] = useState(0);
    const [violationLimit, setViolationLimit] = useState(0);
    const [passThreshold, setPassThreshold] = useState(0);
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { testDetails, isTemplate, tenentUsers } = useSelector(state => state.testLibrary);
    const { selectedTenant } = useSelector((state) => state.users)
    const { accountDetail } = useSelector(state => state.setting);
    const userDetails = JSON.parse(localStorage.getItem("profileDetails"));
    const canInvite = userDetails?.accessMatrix?.canGenerateLink ?? true;

    const { testId } = location.state;

    const firstRender = async () => {
        const { testId } = location.state
        const res = await dispatch(getSelectedTests(testId));
        if (res?.type === 'GET_TEST_DETAILS') {
            const testData = res?.payload || {};

            setTestName(res?.payload?.testName);
            setDescription(res?.payload?.testDescription);
            setDate(res.payload.validTillDate ? res.payload.validTillDate?.split('T')[0] : getDateAfterTwo());
            setAttemptLimit(testData.attemptLimit ?? 0);
            setViolationLimit(testData.violationLimit ?? 0);
            setPassThreshold(testData.passThreshold ?? 0);
        }
        dispatch(getTenantUsers());
        dispatch(getAccountDetail());
       try {
            const tenantId = localStorage.getItem("tenentId");
            const subRes = await dispatch(getSubscriptionPlans(tenantId));
            const subscriptionData = subRes?.data?.data;

            if (subscriptionData) {
                dispatch({ type: "SET_SELECTED_TENANT", payload: { data: subscriptionData } });

                const assessmentFeature = subscriptionData.feature_usages?.find(
                (f) => f.subscription_feature?.code === "ASSESSMENT"
                );

                setAssessmentRemaining(assessmentFeature?.remaining_count ?? 0);
                setSubscriptionLoaded(true);
            } else {
                setSubscriptionLoaded(false);
            }
        } catch (error) {
            console.error("❌ Failed to fetch subscription plans:", error);
            setSubscriptionLoaded(false);
        }

    }

    useEffect(() => {
        document.body.style.overflow = "auto"
        firstRender();
    }, [])


    useEffect(() => {
        HttpClient.get().then(res => setDataInCSV(res));
    }, []);



    const goBack = () => {
        navigate('/home/add-question', {
            state: {
                testId: location.state.testId,
                next: false
            }
        })
    }


    const openAddModal = () => {
        setIsOpen(true);
        setTestName(testDetails.testName);
        setDescription(testDetails?.testDescription);
        setTestNameErr('');
        setShouldValidate(false);
    }


    useEffect(() => {
        if (!shouldValidate) return

        const delay = setTimeout(() => {
            validateNameViaApi(testName);
        }, 500);

        return () => clearTimeout(delay);
    }, [testName, shouldValidate]);



    const validateNameViaApi = async (input) => {
        const res = input !== '' && await dispatch(checkValidTest(input));
        if (res?.payload?.isValid) {
            setTestNameErr('');
        } else {
            setTestNameErr(t('Test Name already exist'));
        }
    };

    const goToQuestion = async () => {
        if (testName.trim('') === '') {
            setTestNameErr(t('Please Enter Test Name'));
        }
        else {
            let obj = {
                "testName": testName,
                testDescription: description,
                testId: location.state.testId
            }
            const res = await dispatch(updateTestName(obj));

            if (res?.type === "UPDATE_TEST_NAME") {
                await setIsOpen(false);
                setTestNameErr('');
                setLoading(true);
                await dispatch(getSelectedTests(testId));
                setLoading(false);
            }
        }
    }

    const updateDate = async (e) => {
        setDate(e)
        setDateError('');
        let obj = {
            testName: testName,
            testDescription: description,
            testId: location.state.testId,
            validTillDate: e
        }
        const res = await dispatch(updateTestName(obj));

        if (res?.type === "UPDATE_TEST_NAME") {
            await setIsOpen(false);
            setTestNameErr('');
        }
    }


    const changeTenentEmail = async (e) => {
        setTenentEmail(e);
    }

    const changeEmail = async (e) => {
        setSuccessMsg('');
        setEmailsError('');
        const isValid = await validateEmails(e);
        if (isValid) {
            setEmails(e);
            setSuccessMsg(t("All emails are valid"));
        } else {
            e.pop();
            setEmails(e);
            setSuccessMsg('');
        }

    }

    const sendInvite = async () => {
        if (date === '') {
            setDateError(t('Date is required'))
        }
        else if (!emails?.length && !tenentEmail?.length && !array?.length) {
            setEmailsError(t('Enter Email address'))
        }

        else {
            setSuccessMsg('');
            setEmailsError('');
            setDateError('');
            setLoading(true);

            let obj = {
                "testInvites": emails?.length ? emails.map(el => [{ name: null, emailId: el.value }][0]).concat(tenentEmail ? tenentEmail.map(el => [{ name: el.label, emailId: el.value }][0]) : []).concat(array ? array.map(el => [{ name: el.Name, emailId: el.EmailId }][0]) : []) : [].concat(tenentEmail ? tenentEmail.map(el => [{ name: el.label, emailId: el.value }][0]) : []).concat(array ? array.map(el => [{ name: el.Name, emailId: el.EmailId }][0]) : []),
                "testId": location.state.testId,
                "testURL": window.location.protocol + '//' + window.location.host + '/candidate-test/token',
                "validTill": moment.utc(new Date(date)).format()
            }
            const prevInvite = accountDetail?.candidateInviteCount;
            const currentInvite = obj.testInvites?.length;
            const totalInvite = prevInvite + currentInvite;
            const inviteAllowed = accountDetail?.accessMatrix?.candidateInvites;
            try {
                if (inviteAllowed == -1) {
                    const res = await dispatch(sendInvites(obj));
                    if (res?.type === 'SEND_INVITES') {
                        navigate('/assessments')
                    } else if (res?.status === 429) {
                        setSuccessEnable(true); // ❌ error snackbar
                        setsuccessMessageText(t('Attempt Limit exceeded for this email'));
                    }
                } else {
                    if (inviteAllowed < totalInvite) {
                        setModalMessage(t("Candidate Limit Exhausted. Please Upgrade Your Plan."))
                        setShowModal(true)
                    }
                    else {
                        const res = await dispatch(sendInvites(obj));
                        if (res?.type === 'SEND_INVITES') {
                            navigate('/assessments')
                        } else if (res?.status === 429) {
                            setSuccessEnable(true);
                            setsuccessMessageText(t('Attempt Limit exceeded for this email'));
                        }
                    }
                }
            } finally {
                setLoading(false);
            }
        }
    }




    const generateLink = () => {
        if (canInvite) {
            const encript = btoa(location.state.testId + '|' + localStorage.getItem('userId'));
            setGeneratetestUrl(window.location.protocol + '//' + window.location.host + "/candidate-invite-test/" + encript);
        }
        else {
            setShowModal(true);
            setModalMessage(t('Please upgrade your plan to generate link'))
        }

    }

    const copyLink = () => {
        var copyText = document.getElementById("gen-link");
        let text = document.getElementById("gen-link").innerHTML;

        // Copy the text inside the text field
        navigator.clipboard.writeText(copyText);
        setSuccessMessage(true);
        setsuccessMessageText(t('Link Copied'));
    }

    const snackClosed = () => {
        setSuccessEnable(false)
        setSuccessMessage(false);
        setsuccessMessageText('');
    }

    const openList = () => {
        setIsList(true)
    }


    const handleOnChange = (e) => {
        e.preventDefault();
        setErrors([]);
        const uploadedFile = e.target.files[0];
        setFile(uploadedFile);

        if (!uploadedFile) return;

        const fileReader = new FileReader();

        fileReader.onload = function (event) {
            try {
            const text = event.target.result;
            csvFileToArray(text);
            setSuccessMessage(true);
            setsuccessMessageText("File uploaded successfully");
            } catch (error) {
            setSuccessEnable(true);
            setsuccessMessageText("Failed to upload file");
            }
        };

        fileReader.onerror = function () {
            console.error("File reading failed");
            setSuccessEnable(true);
            setsuccessMessageText("Failed to upload file");
        };

        try {
            fileReader.readAsText(uploadedFile);
        } catch (error) {
            console.error("Error reading file:", error);
            setSuccessEnable(true);
            setsuccessMessageText("Failed to upload file");
        }
    };

    const csvFileToArray = string => {
        const csvHeader = string.slice(0, string.indexOf("\n")).split(",").map(h => h.trim().toLowerCase());
        const csvRows = string.slice(string.indexOf("\n") + 1).split("\n");

        const array = csvRows.map(i => {
            const values = i.split(",");
            const obj = {};

            csvHeader.forEach((header, index) => {
            let value = values[index]?.replace(/\r$/, '');
            obj[header] = value;
            });

            // Normalize possible header names
            const name = obj['name'] || obj['full name'] || obj['fullname'];
            const email = obj['emailid'] || obj['email'] || obj['mail'];

            if (!isValidEmail(email)) return null;

            return { Name: name, EmailId: email };
        });

        const nonEmptyArray = array.filter(row => row && row.Name);
        setArray(nonEmptyArray);
    };

    const isValidEmail = email => {
        // Regular expression for email validation
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const removeUser = (el) => {
        const filtered = array.filter(e => e.EmailId !== el.EmailId)
        setArray(filtered)
    }

    const handleModal = () => {
        setShowModal(false);

    }

    const saveAssessmentSettings = async () => {
        setLoading(true);
        const payload = {
            attemptLimit: Number(attemptLimit) || 0,
            violationLimit: Number(violationLimit) || 0,
            passThreshold: Number(passThreshold) || 0,
            testId: location.state.testId
        };

        try {
            const res = await dispatch(updateAssessmentSettings(payload));
            if (res?.status === 200) {
                await firstRender();
                setSuccessMessage(true);
                setsuccessMessageText(t('Assessment settings saved'));
            } else {
                const msg = res?.data?.responseMessages?.[0]?.message || t('Failed to save assessment settings');
                setSuccessEnable(true);
                setsuccessMessageText(msg);
            }
        } catch (error) {
            const msg = error?.response?.data?.responseMessages?.[0]?.message || error?.message || t('Failed to save assessment settings');
            setSuccessEnable(true);
            setsuccessMessageText(msg);
        } finally {
            setLoading(false);
        }
        };

    return (
        <div className='gappeo-test-results'>
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                open={successMessage}
                onClose={snackClosed}
                autoHideDuration={4000}
            >
                <Alert onClose={snackClosed} severity="success" sx={{ width: '100%' }}>
                    {successMessageText}
                </Alert>
            </Snackbar>
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                open={successEnable}
                onClose={snackClosed}
                autoHideDuration={4000}
            >
                <Alert onClose={snackClosed} severity="error" sx={{ width: '100%' }}>
                    {successMessageText}
                </Alert>
            </Snackbar>

            <Dialog
                className='screen-loader'
                open={loading}
                onClose={() => { }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                {t('Loading..', { ns: 'home' })}
            </Dialog>
            {!isTemplate ?
                <Fragment>
                    <div className='gappeo-test-header'>
                        {/* <div className='gappeo-test-header-top'>
                            {testDetails.testName.length > 0 ? <h3>{testDetails?.testName || location.state.testDetails?.testName}</h3> : <h3>Test Name</h3>}   
                        </div> */}
                    </div>
                        <Stepper
                        type='preview'
                        goBack={goBack}
                        myTest={location.state.myTest}
                        />
                    

                    <div className='gappeo-test-lists test-preview'>
                        <div className='gappeo-preview'>
                            {
                                window.innerWidth > 767 ?
                                    <div className='preview-header'>
                                        <div className='d-flex align-items-center' style={{gap:'35px'}}>
                                            <div style={{borderRight:'1px solid #FFFFFF', width:'236px'}}>
                                                <p>{t('Assessment Summary', { ns: 'home' })}</p>
                                                <h3 >{testDetails?.testName || location.state.testDetails?.testName} &nbsp; {!location.state.myTest && <img src='/images/edit-icon.svg' className='cursor-pointer' alt='' onClick={openAddModal} />}</h3>
                                            </div>
                                            <div className='d-flex' style={{gap:'28px'}}>
                                                <div style={{width:'70px'}}>
                                                    <h2>{location.state.testDetails?.testDetails?.tests?.length || testDetails?.testDetails?.tests?.length}</h2>
                                                    <span>{t('Tests', { ns: 'home' })}</span>
                                                </div>
                                                <div style={{width:'70px'}}>
                                                    <h2>{testDetails?.questionCount || location.state.testDetails?.questionCount}</h2>
                                                    <span>{t('Questions', { ns: 'home' })}</span>
                                                </div>
                                                <div style={{width:'70px'}}>
                                                    <h2>{testDetails?.duration || location.state.testDetails?.duration}</h2>
                                                    <span>{t('Minutes', { ns: 'home' })}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <button className='detail-btn' onClick={() => setIsDetail(true)}>+&nbsp;&nbsp;&nbsp;&nbsp;{t('View Details', { ns: 'home' })}</button>
                                            {/* <h6>Save & Exit</h6> */}
                                        </div>
                                    </div> :
                                    <div className='gappeo-mobile-header'>
                                        <div className='selected-list-header d-flex justify-content-between align-items-end'>
                                            <div>
                                                <h4>{t('Assessment Summary', { ns: 'home' })}</h4>
                                                <h4 className='d-flex justify-content-start align-items-center' style={{ color: '#fff', fontSize: 18 }}>{testDetails?.testName}&nbsp;&nbsp;
                                                    <img src='/images/edit-icon.svg' alt='' className='cursor-pointer' onClick={() => openAddModal()} /></h4>
                                                <h5 >{testDetails?.testDetails?.tests?.length} {t('test', { ns: 'home' })} | {testDetails?.questionCount} {t('Qs', { ns: 'home' })} | {testDetails?.duration} {t('Mins', { ns: 'home' })}</h5>
                                                <p>{t('Level', { ns: 'home' })}: {testDetails?.testLevelName}</p>
                                            </div>
                                            <button className='outline-btn ms-4' onClick={() => setIsDetail(true)}>{t('View Details', { ns: 'home' })}</button>
                                        </div>
                                    </div>
                            }
                            <div className="assessment-settings">
                                <div className='assessment-settings-head'>
                                    <h1>{t('Assessment Settings', { ns: 'home' })}</h1>
                                </div>
                                <div style={{padding:'12px'}}>
                                    <div className="row">
                                        <div className="form-group col-md-6">
                                        <label>{t('Attempt Limit', { ns: 'home' })}</label>
                                        <input
                                            type="number"
                                            min="0"
                                            className="form-control mt-2"
                                            value={attemptLimit}
                                            onChange={(e) => {
                                            const val = Number(e.target.value);
                                            setAttemptLimit(val < 0 || Number.isNaN(val) ? 0 : val);
                                            }}
                                        />
                                        </div>

                                        <div className="form-group col-md-6">
                                        <label>{t('Violation Limit', { ns: 'home' })}</label>
                                        <input
                                            type="number"
                                            min="0"
                                            className="form-control mt-2"
                                            value={violationLimit}
                                            onChange={(e) => {
                                            const val = Number(e.target.value);
                                            setViolationLimit(val < 0 || Number.isNaN(val) ? 0 : val);
                                            }}
                                        />
                                        </div>

                                        <div className="form-group col-md-6">
                                        <label>{t('Pass Threshold', { ns: 'home' })}</label>
                                        <input
                                            type="number"
                                            min="0"
                                            className="form-control mt-2"
                                            value={passThreshold}
                                            onChange={(e) => {
                                            const val = Number(e.target.value);
                                            setPassThreshold(val < 0 || Number.isNaN(val) ? 0 : val);
                                            }}
                                        />
                                        </div>
                                    </div>
                                    <div style={{ marginTop: 12 }}>
                                        <button className="invite-btn"onClick={async () => {await saveAssessmentSettings();}}>
                                        {t('Save', { ns: 'home' })}
                                        </button>
                                    </div>
                                </div>
                                </div>
                            <div className='invite-details'>
                                <div className='invite-details-head'>
                                    <h1>{t('Invite candidates', { ns: "home" })}</h1>
                                </div>
                                <div style={{padding:'12px'}}>
                                    <div className='row'>
                                        <div className='form-group col-md-6'>
                                            <label>{t('Test valid until', { ns: 'home' })}</label>
                                            <div>
                                                <input type='date' placeholder='Select Date' min={getDateAfterTwo()} className='form-control mt-2' value={date} onChange={(e) => {
                                                    updateDate(e.target.value)
                                                }} />
                                            </div>
                                            <small style={{ color: 'red' }}>{dateError}</small>
                                        </div>
                                        <div className='form-group col-md-6'>
                                            <label>{t('Invite team members', { ns: 'home' })}</label>
                                            <div className='email-input'>
                                                <Select isMulti
                                                    placeholder={t('Enter email ids', { ns: 'home' })} options={tenentUsers}
                                                    value={tenentEmail}
                                                    onChange={(e) => changeTenentEmail(e)} />
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className='form-group'>
                                            <label>{t('Candidate List', { ns: 'home' })}</label>
                                            <p className='mb-2'>{t('You can invite as many candidates as the credits available', { ns: 'home' })} &nbsp;<span style={{ color: '#009199' }}>
                                                <a
                                                    href={`data:text/csv;charset=utf-8,${escape(dataInCSV)}`}
                                                    download="samplecsv.csv"
                                                    style={{ color: '#009199' }}
                                                >
                                                    {t('Sample CSV File', { ns: 'home' })}
                                                </a>
                                            </span></p>
                                            <div className='list-header'>
                                                <div className='div1 d-flex align-items-start flex-column'>
                                                    <div className='count'>
                                                        {subscriptionLoaded
                                                            ? assessmentRemaining
                                                            : (accountDetail?.balanceCredit === 0
                                                                ? accountDetail?.additionalCreditLeftCount
                                                                : accountDetail?.balanceCredit)}
                                                        </div>
                                                    <span>{t('Invite credits available', { ns: 'home' })}</span>
                                                </div>
                                                <div className='div2 d-flex align-items-start flex-column'>
                                                    <div className='count'>{accountDetail?.candidateInviteCount || 0}</div>
                                                    <span>{t('Candidates Added', { ns: 'home' })}</span>
                                                </div>
                                                <div className='div3 d-flex align-items-center'>
                                                    {/* <img src='/images/upload-icon-white.png' alt='' /> */}
                                                    <span className='view-list-button curser-pointer' style={{ fontSize: 14, fontWeight: 600}}>
                                                        <div className='file-upload curser-pointer'>
                                                            <input type='file' accept={".csv"}
                                                                onChange={handleOnChange} />
                                                        </div>
                                                        {t('Upload From File', { ns: 'home' })}
                                                    </span>
                                                </div>
                                                <div className='div3 d-flex align-items-center'>
                                                    <span className='view-list-button' style={{ fontSize: 14, fontWeight: 600, cursor: !array?.length ? '' : 'pointer' }} onClick={() => !array?.length ? '' : openList()}>{t('View List', { ns: 'home' })}</span>
                                                </div>
                                                {/* <div className='div3 d-flex align-items-center justify-content-center'>
                                                    <span className='view-list-button' onClick={() => setIsDetail(true)}>{t('View details', { ns: 'home' })}</span>
                                                </div> */}
                                            </div>
                                            <div className='email-input'>
                                                <span>{t('Invite candidates', { ns: 'home' })}</span>
                                                <CreatableSelect
                                                    isMulti placeholder={t('Enter email ids', { ns: 'home' })} onChange={(e) => changeEmail(e)} />
                                            </div>
                                            {
                                                errors && errors.map(el => {
                                                    return (
                                                        <Fragment>
                                                            <small style={{ color: 'red' }}>{el}</small>
                                                            <br />
                                                        </Fragment>
                                                    )
                                                })
                                            }
                                            {
                                                successMsg ?
                                                    <small style={{ color: '#02c573' }}><img src='/images/tick-mark.svg' width={15} alt='' />&nbsp;{successMsg}</small> :
                                                    emailsError ?
                                                        <small style={{ color: 'red' }}>{emailsError}</small>
                                                        : null

                                            }
                                        </div>
                                    </div>
                                    <div className='email-template'>
                                        <div className='form-group'>
                                            <div className='template-divs'>
                                                <div className='template-div'>
                                                    <div className='d-flex align-items-center justify-content-between'>
                                                        <p>{t('Invitation Template', { ns: "home" })}</p>
                                                        <h4 className='cursor-pointer' onClick={() => dispatch(getInvitationTemplates(testId, 1, false))}>+&nbsp;&nbsp;{t('View / Edit', { ns: 'home' })}</h4>
                                                    </div>
                                                </div>
                                                <div className='template-div'>
                                                    <div className='d-flex align-items-center justify-content-between'>
                                                        <p>{t('Reminder template', { ns: 'home' })}</p>
                                                        <h4 className='cursor-pointer' onClick={() => dispatch(getInvitationTemplates(testId, 2, false))}>+&nbsp;&nbsp;{t('View / Edit', { ns: 'home' })}</h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {generatetestUrl &&
                                    <div>
                                        <a id='gen-link' style={{ color: "#009199", padding:'0 24px' }} href={generatetestUrl} rel="noreferrer" target='_blank'>{generatetestUrl}</a>&nbsp;&nbsp;<img src='/images/copy.png' className='cursor-pointer' onClick={copyLink} alt='' />
                                    </div>
                                }
                                <div className='d-flex justify-content-left' style={{gap:'6px', padding:'0 12px'}}>
                                    <button className='generate-btn' onClick={generateLink}> {t('Generate Link', { ns: 'home' })}</button>
                                    <button className='invite-btn' disabled={loading} onClick={sendInvite}>{t('Send Invites', { ns: "home" })}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment> :
                <Template
                    testId={location.state.testId}
                />
            }


            <AddTestModal
                edit={true}
                isOpen={isOpen}
                setIsOpen={() => setIsOpen(false)}
                testName={testName}
                testNameErr={testNameErr}
                setTestName={(e) => setTestName(e)}
                setTestNameErr={(e) => setTestNameErr(e)}
                description={description}
                setDescription={(val) => setDescription(val)}
                goToQuestion={goToQuestion}
            />


            {/* //Details Modal */}
            <TestDetailModal
                isLoading={false}
                isDetail={isDetail}
                testDetails={testDetails}
                setIsDetail={() => setIsDetail(false)}
            />

            {/* candidate list model */}
            <Modal
                show={isList}
                size={window.innerWidth > 767 ? "lg" : 'md'}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                dialogClassName={"candidate-list"}
            >
                <Modal.Body>
                    <div className='sticky-close'>
                        <img src='/images/close.svg' alt='' onClick={() => setIsList(false)} />
                    </div>
                    <h3>{t('Candidate List', { ns: 'home' })}</h3>
                    <div className='candidate-table mt-3'>
                        <Table responsive>
                            {array.map((item) => (
                                <tr key={item.id}>
                                    {Object.values(item).map((val) => (
                                        <td>{val}</td>
                                    ))}
                                    <td><img src='/images/delete-icon.svg' alt='' onClick={() => removeUser(item)} /></td>
                                </tr>
                            ))}
                        </Table>
                    </div>
                </Modal.Body>

            </Modal>

            <Modal
                show={showModal}
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                dialogClassName={"detail-modal"}
            >
                <div className="modal-header" style={{ background: "#009199" }}>
                    <h5 className="modal-title">{"Upgrade"} </h5>

                    <div className="sticky-close" onClick={handleModal}>
                        <img src="/images/close-white.svg" width="15px" alt="" />
                    </div>
                </div>
                <Modal.Body style={{ padding: "22px", textAlign: "center" }}>
                    <h1>😃</h1>
                    <h3>{modalMessage}</h3>
                </Modal.Body>
            </Modal>


        </div >
    )
}
